import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const Styled = {
    Bullet: styled(Box)(({ theme }) => ({
        display: 'inline-flex',
        alignItems: 'center',
        padding: theme.spacing(0.25, 1),
        borderRadius: theme.spacing(0.75),
        span: {
            borderRadius: '100%',
            width: '7px',
            height: '7px',
            flexShrink: 0,
        },
    })),
    Label: styled(Typography)(() => ({
        marginInlineStart: '6px',
        lineHeight: 1.5,
        fontSize: '12px',
        fontWeight: 500,
        textWrap: 'nowrap',
    })),
};

export { Styled };
